module.exports = __webpack_public_path__ + "img/padlock-locked.05869342.svg";